import { Box, Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { com } from '@eidu/web'
import { Download } from '@mui/icons-material'
import EntityFieldDisplayGroup from '../shared/EntityFieldDisplayGroup'
import PageLayout from '../shared/PageLayout'
import { KindViewPageProps } from '../KindPages'
import useHasPermission from '../../../permission/useHasPermission'
import getResourceUrl from '../../../../io/api/resource/getResourceUrl'
import { getResourceKeyFromEntity } from '../../../../io/entityResourceKeyLink'
import useIsPublishable from '../asset/publish/useIsPublishable'
import PublishDialog from '../asset/publish/PublishDialog'
import VersionHistoryDrawer from '../asset/publish/VersionHistoryDrawer'
import usePublishStatus from '../asset/publish/usePublishStatus'
import PublishStatusChip from '../asset/publish/PublishStatusChip'
import EntityAction = com.eidu.sharedlib.entity.permission.EntityAction

const RuntimeViewPage = ({ entity, entityType, fields }: KindViewPageProps) => {
  const navigate = useNavigate()

  const { hasPermission: hasUpdatePermission } = useHasPermission(entity.entity.id, EntityAction.UpdateEntity)
  const { publishable } = useIsPublishable(entity, entityType)

  const navigateToEdit = () => {
    navigate(`/entities/${entityType.id.toString()}/edit/${entity.entity.id.toString()}`)
  }

  const resourceKey = getResourceKeyFromEntity(entity)
  const resourceUrl = resourceKey ? getResourceUrl(resourceKey) : undefined
  const publishStatus = usePublishStatus({ entity })

  return (
    <PageLayout
      title={entity.primaryLabelText}
      subtitle={entityType.name}
      auditTargetId={entity.entity.id.toString()}
      actions={
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          {publishable && (
            <>
              <PublishStatusChip status={publishStatus} entityType={entityType} currentResourceKey={resourceKey} />
              <PublishDialog entityId={entity.entity.id} />
              <VersionHistoryDrawer entityId={entity.entity.id} />
            </>
          )}
          {hasUpdatePermission && <Button onClick={navigateToEdit}>Edit</Button>}
        </Stack>
      }
      showBack
    >
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', pt: 1.5 }}>
        <EntityFieldDisplayGroup entityType={entityType} fields={fields} />
        {resourceUrl && (
          <Stack spacing={1} sx={{ mt: 2 }}>
            <Typography variant="subtitle2">Payload</Typography>
            <Button
              variant="outlined"
              startIcon={<Download />}
              href={resourceUrl}
              download
              sx={{ alignSelf: 'flex-start' }}
            >
              Download
            </Button>
          </Stack>
        )}
      </Box>
    </PageLayout>
  )
}

export default RuntimeViewPage
